/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PhoneChat/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PhoneChat({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PhoneChat",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PhoneChat.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-1kijQW': alignSelf,'--mt-2-1kijQW': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1kijQW': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1kijQW': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1kijQW': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1kijQW': opacity,'--w-10-1kijQW': typeof width === 'number' ? `${width}px` : width,'--h-11-1kijQW': typeof height === 'number' ? `${height}px` : height,'--f-12-1kijQW': fill,'--a-7-1kijQW': isAnimated ? animation : "none",'--sd-8-1kijQW': isAnimated ? strokeDashoffset : 0,'--sd-9-1kijQW': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2PhoneChat.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.75 1.5a.25.25 0 00-.25.25v10.489a.53.53 0 00.123.148.753.753 0 00.179.113H8.25a.25.25 0 00.25-.25V8.5a.75.75 0 011.5 0v3.75A1.75 1.75 0 018.25 14h-6.5c-.232 0-.448-.077-.602-.15-.17-.08-.342-.19-.498-.322-.289-.246-.65-.686-.65-1.278V1.75C0 .784.784 0 1.75 0H4a.75.75 0 010 1.5H1.75zM9.5 6.438l-2.74.782a.5.5 0 01-.63-.563l.37-2.22v-3a1 1 0 011-1H13a1 1 0 011 1v4a1 1 0 01-1 1H9.5zm-5 3.312a.75.75 0 000 1.5h1a.75.75 0 000-1.5h-1z"
 style={{'--f-12-1kijQW': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}